export const GAME_PERSISTENCE_KEY = 'video-poker';
